import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { communicationsModuleManifest } from '../communications.module.js';
import { communicationsSettingRegistrations } from '../settings/communications-setting-definitions.js';
export const communicationsWebModuleContribution = {
    moduleId: 'communications',
    manifest: communicationsModuleManifest,
    settingRegistrations: communicationsSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'communications.web.projects.portal-messages',
            moduleId: 'communications',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'communications.portal-messages.read',
            settingCondition: {
                key: 'communications.portal-messages.configuration',
                property: 'staffProjectPanelEnabled',
                equals: true,
            },
            priority: 70,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Messages',
                fallbackDescription: 'Open customer and Project communication activity.',
                defaultSize: 'standard',
                supportedSizes: ['compact', 'standard', 'wide'],
            }),
            load: () => import('./communications-portal-project-messages.panel.js'),
        }],
    routes: [],
};
export default communicationsWebModuleContribution;
//# sourceMappingURL=communications-web.module-contribution.js.map